export const UPDATE_POINTS = "UPDATE_POINTS"